export default __webpack_public_path__ + "static/media/fpx.0f19fb02.png";